import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/generate/errorLog/page', data, {
    trim: true
  })
}

// 删除
export function deleteById (id) {
  return request.get(`/generate/errorLog/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/generate/errorLog/delete/batch', {
    params: {
      ids
    }
  })
}
